import script from "./srmOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./srmOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./srmOrderRecord.vue?vue&type=style&index=0&id=7efb7bb4&lang=scss"

const __exports__ = script;

export default __exports__